import {List} from 'immutable';
import {Moment} from 'moment';
import * as moment from 'moment';

import {
    INewModelOptions,
    IModelCreatorService
} from '../../discharge/model-creator.service';
import {IDischargeDataItem} from '../../discharge/data-list/discharge-data-list.controller';
import {IDischargeModel} from '../../api/api.types';
import {IDischargeModelApi} from '../../api/discharge-model-api.service';

export interface ICurveCreatorController {
  resetCreatorForm():void;
}

export interface ICurveCreatorParent {
  addCurveCreatorController(curveCreatorController:ICurveCreatorController):void;
}

export default class CurveCreatorController implements ICurveCreatorController {
  static $inject = ['modelCreatorService'];
  /**
   * Options for the creation of a new model.
   */
  newModelOptions:INewModelOptions;
  /**
   * Displayed form for the new model options.
   */
  newModelForm:ng.IFormController;
  /**
   * Parent controller.
   */
  parent:ICurveCreatorParent;
  /**
   * ID of the selected model for delta H adjustment.
   */
  selectedModelId:number;
  /**
   * Reference discharge models for delta H adjustment.
   */
  dischargeModels:IDischargeModel[];
  /**
   * Selected discharge measurements for model fitting.
   */
  selectedDischargeDataItems:List<IDischargeDataItem>;
  /**
   * Newly created model.
   */
  newModel:IDischargeModel;
  /**
   * Starting overriddenDate for new models
   */
  startingDate:Moment;
  /**
   * Callback to notify a change in the new model, i.e. creation/deletion.
   */
  onNewModelChange:(callbackArgs:{
    newModel:IDischargeModel, created:boolean})=>void;

  constructor(private modelCreatorService:IModelCreatorService) {
    this.newModelOptions = {
      creationMode: 'deltaH',
      name: null,
      selectedDischargeDataItems: List<IDischargeDataItem>(),
      date: moment()
    };
  }

  get disabledNewModelButton() {
    return !this.modelCreatorService.validateOptions(this.newModelOptions);
  }

  $onInit() {
    if (this.parent) {
      this.parent.addCurveCreatorController(this);
    }
  }

  $onChanges() {
    this.newModelOptions.date = this.startingDate;
    this.newModelOptions.selectedDischargeDataItems =
        this.selectedDischargeDataItems || List<IDischargeDataItem>();
  }

  resetCreatorForm() {
    this.selectedModelId = null;
    this.newModelOptions = {
      date: this.startingDate || moment(),
      name: null,
      deltaH: null,
      creationMode: 'deltaH',
      referenceModel: null,
      selectedDischargeDataItems: this.newModelOptions
          .selectedDischargeDataItems
    };
    if (this.newModelForm) {
      this.newModelForm.$setPristine();
      this.newModelForm.$setUntouched();
    }
  }

  onModelSelect() {
    this.newModelOptions.referenceModel = this.dischargeModels
        .find(dischargeModel => dischargeModel.id == this.selectedModelId);
  }

  createNewModel() {
    this.newModel = this.modelCreatorService.createModel(this.newModelOptions);
    this.notifyNewModelChange(true);
    this.resetCreatorForm();
  }

  deleteNewModel() {
    this.newModel = null;
    this.notifyNewModelChange(false);
  }

  private notifyNewModelChange(created:boolean) {
    if (this.onNewModelChange) {
      this.onNewModelChange({
        newModel: this.newModel,
        created
      });
    }
  }

}



/** WEBPACK FOOTER **
 ** ./app/operational/input/curve-creator.controller.ts
 **/